<template>
    <transition :name="$device.isDesktop ? 'cart-fade' : 'fade'" duration="600">
        <div class="cart text_11" v-if="isShowCart" :class="!allowChange ? 'blocked' : 'editable'">
            <div class="cart__modal" v-if="totalCartItems > 0">
                <div class="cart__content">
                    <transition name="fade">
                        <div class="count-restriction" v-if="isShowCountRestriction">
                            <div>{{ $t("count_warning") }}</div>
                        </div>
                    </transition>
                    <div class="mobile-cart-top" v-if="!$device.isDesktop && allowChange">
                        <div class="mobile-cart-top__left">
                            <div class="mobile-cart-top__logo">
                                <nuxt-link to="/" @click.native="close()">
                                    <svg-icon name="logo" width="88" height="36" />
                                </nuxt-link>
                            </div>
                        </div>
                        <div class="mobile-cart-top__right">
                            <svg-icon name="close" @click="close()" width="32" height="32" />
                        </div>
                    </div>
                    <div class="cart__header" v-if="allowChange">
                        <div class="container text_13">
                            <span>{{ $t("cart") }}</span>
                            <div class="cart__close" @click="close()" v-if="$device.isDesktop">{{ $t("close") }}</div>
                        </div>
                    </div>
                    <div class="cart__header" v-else>
                        <div class="container">
                            <span
                                >{{ $t("yr_order")
                                }}<span class="cart__count" v-if="!$device.isDesktop">{{ totalCartItems }}</span></span
                            >
                            <template v-if="!$device.isDesktop">
                                <Loader inline v-if="isDeliveresLoading"></Loader>
                                <div v-else class="text_19 cart-total">
                                    {{
                                        (
                                            parseInt(("" + cartTotal).replace(/\s+/g, "")) +
                                            (deliveryCost > 0 ? deliveryCost : 0) -
                                            (cartTotalDiscount ? cartTotalDiscount : 0)
                                        ).toLocaleString("ru-RU")
                                    }}
                                    <span class="money">{{ currency }}</span>
                                </div>
                                <div class="summary">
                                    <div
                                        class="summary__item"
                                        :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                        <div class="summary__label">
                                            {{ $t("items_worth") }}
                                        </div>
                                        <div class="summary__value summary__value--price" id="carrotCartTotal">
                                            {{ cartTotal }} <span class="money">{{ currency }}</span>
                                        </div>
                                    </div>
                                    <div
                                        class="summary__item"
                                        :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                        <div class="summary__label">{{ $t("delivery") }}</div>
                                        <div class="summary__value" :class="{ has_value: deliveryCost }">
                                            <Loader inline v-if="isDeliveresLoading"></Loader>
                                            <template v-else>
                                                <template v-if="deliveryCost && deliveryCost > 0">
                                                    {{ deliveryCost.toLocaleString("ru-RU") }}
                                                    <span class="money">{{ currency }}</span>
                                                </template>
                                                <template v-else-if="deliveryCost == 0 && deliveryCost !== null">
                                                    {{ $t("free") }}
                                                </template>
                                                <template v-else>
                                                    {{ $t("clac_next") }} <Hint :hint="$t('free_delivery_cost')" />
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                    <div
                                        class="summary__item"
                                        v-if="cartTotalDiscount >= 0 && discountInfo.discountType == 'promo-code'"
                                        :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                        <div class="summary__label">
                                            {{ $t("promo") }}
                                            {{ $store.getters["order/getPromoValue"] }}
                                        </div>
                                        <div class="summary__value">
                                            -{{ cartTotalDiscount.toLocaleString("ru-RU") }}
                                            <span class="money">{{ currency }}</span
                                            ><svg-icon name="close--small" width="8" height="8" @click="resetPromo()" />
                                        </div>
                                    </div>
                                    <div
                                        class="summary__item"
                                        v-if="appliedBonuses > 0 && discountInfo.discountType == 'bonuses'"
                                        :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                        <div class="summary__label">
                                            {{ $t("pps_club") }}
                                        </div>
                                        <div class="summary__value">
                                            -{{ appliedBonuses.toLocaleString("ru-RU") }}
                                            <span class="money">{{ currency }}</span
                                            ><svg-icon name="close--small" width="8" height="8" @click="resetBonuses" />
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="cart__edit color-text_2" v-if="$device.isDesktop" @click="editOrder">
                                {{ $t("edit_order") }}
                            </div>
                            <div class="discounts" v-if="!allowChange && !$device.isDesktop && !discountInfo.isApply">
                                <div class="promocode__form" v-if="!cartTotalDiscount">
                                    <div class="form-group">
                                        <Input
                                            inputClass="form-group__input form-group__input--promocode black-border"
                                            name="promocode"
                                            :label="$t('enter_promo')"
                                            :isValid="promoValidation.isValid"
                                            :validationMessage="promoValidation.validationMessage"
                                            v-model="promocode" />
                                        <button
                                            class="button button--padding-0-18 button--height-33 text_11 carrot-button"
                                            v-if="promocode == '' || promocode != $store.getters['order/getPromoValue']"
                                            @click="applyPromo(promoData)">
                                            {{ $t("apply") }}
                                        </button>
                                        <button
                                            class="button button--padding-0-18 button--height-33 text_11 carrot-button"
                                            v-else
                                            @click="resetPromo()">
                                            {{ $t("cancel") }}
                                        </button>
                                    </div>
                                    <div
                                        class="drop-warning"
                                        v-if="hasDropItems"
                                        :class="{
                                            'drop-warning--aaaaaaa': invalidPromocode,
                                            'drop-warning--offset':
                                                !promoValidation.isValid && promoValidation.validationMessage,
                                        }">
                                        <svg-icon name="attantion" width="8" height="8" />
                                        {{ $t("has_drop_items") }}
                                    </div>
                                </div>
                                <div class="bonuses__form" v-if="!appliedBonuses">
                                    <nuxt-link to="/loyalty-program">{{ $t("pps_club") }}</nuxt-link>
                                    <div class="form-group" v-if="$auth.loggedIn && $auth.user.loyalty.amount > 0">
                                        <Input
                                            inputClass="form-group__input"
                                            name="bonuses"
                                            :label="bonusesPlaceholder"
                                            :isValid="bonusesValidation.isValid"
                                            :disabled="!bonusesValidation.isValid"
                                            :validationMessage="bonusesValidation.validationMessage"
                                            v-model="bonuses"
                                            ref="bonuses" />
                                        <button
                                            class="button button--padding-0-18 button--height-33 text_11"
                                            v-if="true"
                                            @click="applyBonuses">
                                            {{ $t("apply") }}
                                        </button>
                                        <button class="button button--padding-0-18 button--height-33 text_11" v-else>
                                            {{ $t("cancel") }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="cart__mobile-list-toggler"
                            :class="{
                                is_open: isMobileListOpen,
                                'color-text_2': allowChange,
                                'color-text_1': !allowChange,
                            }"
                            v-if="!$device.isDesktop">
                            <div class="text_11" @click="isMobileListOpen = !isMobileListOpen">
                                <template v-if="isMobileListOpen">
                                    {{ $t("close_order") }} <svg-icon name="arrow-down" width="8" height="8" />
                                </template>
                                <template v-else>
                                    {{ $t("show_order") }} <svg-icon name="arrow-down" width="8" height="8" />
                                </template>
                            </div>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="summary" v-if="allowChange || (!allowChange && $device.isDesktop)">
                            <div class="container">
                                <div
                                    class="summary__item"
                                    :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                    <div class="summary__label">
                                        {{ $t("items") }} <span class="cart__count">{{ totalCartItems }}</span>
                                    </div>
                                    <div class="summary__value" id="carrotCartTotal">
                                        {{ cartTotal }} <span class="money">{{ currency }}</span>
                                    </div>
                                </div>
                                <div
                                    class="summary__item"
                                    :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                    <div class="summary__label">{{ $t("delivery") }}</div>
                                    <div class="summary__value summary__value--price" v-if="$device.isDesktop">
                                        <Loader inline v-if="isDeliveresLoading"></Loader>
                                        <template v-else>
                                            <template v-if="deliveryCost != null">
                                                <template v-if="deliveryCost > 0">
                                                    {{ deliveryCost.toLocaleString("ru-RU") }}
                                                    <span class="money">{{ currency }}</span>
                                                </template>
                                                <template v-else>
                                                    {{ $t("free") }}
                                                </template>
                                            </template>
                                            <template v-else>
                                                {{ $t("calc_when_place") }}
                                            </template>
                                        </template>
                                    </div>
                                    <div class="summary__value" :class="{ has_value: deliveryCost }" v-else>
                                        <Loader inline v-if="isDeliveresLoading"></Loader>
                                        <template v-else>
                                            <template v-if="deliveryCost">
                                                {{ deliveryCost.toLocaleString("ru-RU") }}
                                                <span class="money">{{ currency }}</span>
                                            </template>
                                            <template v-else> {{ $t("clac_next") }} </template>
                                        </template>
                                    </div>
                                </div>
                                <div
                                    class="summary__item"
                                    v-if="cartTotalDiscount >= 0 && discountInfo.discountType == 'promo-code'"
                                    :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                    <div class="summary__label">
                                        {{ $t("promo") }}
                                        {{ promocode }}
                                        <svg-icon name="close--small" width="8" height="8" @click="resetPromo" />
                                    </div>
                                    <div class="summary__value">
                                        -{{ cartTotalDiscount.toLocaleString("ru-RU") }}
                                        <span class="money">{{ currency }}</span>
                                    </div>
                                </div>
                                <div
                                    class="summary__item"
                                    v-if="appliedBonuses > 0 && discountInfo.discountType == 'bonuses'"
                                    :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                    <div class="summary__label">
                                        {{ $t("pps_club") }}
                                        <svg-icon name="close--small" width="8" height="8" @click="resetBonuses" />
                                    </div>
                                    <div class="summary__value">
                                        -{{ appliedBonuses.toLocaleString("ru-RU") }}
                                        <span class="money">{{ currency }}</span>
                                    </div>
                                </div>
                                <div class="summary__item text_19">
                                    <div class="summary__label">{{ $t("subtotal") }}</div>
                                    <Loader inline v-if="isDeliveresLoading"></Loader>
                                    <div v-else class="summary__value summary__value--price">
                                        {{
                                            (
                                                parseInt(("" + cartTotal).replace(/\s+/g, "")) +
                                                (deliveryCost > 0 ? deliveryCost : 0) -
                                                (cartTotalDiscount ? cartTotalDiscount : 0)
                                            ).toLocaleString("ru-RU")
                                        }}
                                        <span class="money">{{ currency }}</span>
                                    </div>
                                </div>
                                <template v-if="allowChange">
                                    <!-- @click="$fb.fbq('track', 'InitiateCheckout')" -->
                                    <nuxt-link
                                        class="cart__checkout"
                                        v-if="isReachMinimumOrderPrice"
                                        @click.native="close"
                                        :to="zakazRoute"
                                        >{{ $t("make_order") }}</nuxt-link
                                    >
                                    <div class="cart__checkout cart__checkout--locked" v-else>
                                        {{ $t("min_order") }} {{ this.minimumOrderPrice.toLocaleString("ru-RU") }}
                                        {{ currency }}
                                    </div>
                                    <div
                                        class="text_11 cart__coninue-shopping button button--text button--wide color-text_1"
                                        @click="close()">
                                        {{ $t("cont_shop") }}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </transition>
                    <div class="discounts" v-if="!allowChange && $device.isDesktop && !discountInfo.isApply">
                        <div class="promocode__form" v-if="!cartTotalDiscount">
                            <div class="form-group">
                                <Input
                                    inputClass="form-group__input"
                                    name="promocode"
                                    :isValid="promoValidation.isValid"
                                    :validationMessage="promoValidation.validationMessage"
                                    :label="$t('enter_promo')"
                                    v-model="promocode" />
                                <button
                                    class="button button--padding-0-18 button--height-33 text_11"
                                    v-if="promocode == '' || promocode != $store.getters['order/getPromoValue']"
                                    @click="applyPromo(promoData)">
                                    {{ $t("apply") }}
                                </button>
                                <button
                                    class="button button--padding-0-18 button--height-33 text_11"
                                    v-else
                                    @click="resetPromo()">
                                    {{ $t("cancel") }}
                                </button>
                            </div>

                            <div
                                class="drop-warning"
                                v-if="hasDropItems"
                                :class="{
                                    'drop-warning--aaaaaaa': invalidPromocode,
                                    'drop-warning--offset':
                                        !promoValidation.isValid && promoValidation.validationMessage,
                                }">
                                <svg-icon name="attantion" width="8" height="8" />
                                {{ $t("has_drop_items") }}
                            </div>
                        </div>
                        <div class="bonuses__form" v-if="!appliedBonuses">
                            <nuxt-link to="/loyalty-program">{{ $t("pps_club") }}</nuxt-link>
                            <div class="form-group" v-if="$auth.loggedIn && $auth.user.loyalty.amount > 0">
                                <Input
                                    inputClass="form-group__input"
                                    name="bonuses"
                                    :label="bonusesPlaceholder"
                                    :isValid="bonusesValidation.isValid"
                                    :disabled="!bonusesValidation.isValid"
                                    :validationMessage="bonusesValidation.validationMessage"
                                    v-model="bonuses"
                                    ref="bonuses" />
                                <button
                                    class="button button--padding-0-18 button--height-33 text_11"
                                    v-if="true"
                                    @click="applyBonuses">
                                    {{ $t("apply") }}
                                </button>
                                <button class="button button--padding-0-18 button--height-33 text_11" v-else>
                                    {{ $t("cancel") }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="cart__list" v-if="$device.isDesktop || isMobileListOpen || allowChange">
                            <div class="container" v-bsl="isShowCart && allowChange">
                                <CartItem
                                    v-for="(item, index) in preparedCartItems"
                                    :key="index"
                                    :item="item"
                                    :allowChange="allowChange"
                                    :editedItem="editedItem"
                                    :orderItems="orderItems"
                                    @update:isShowCart="isShowCart = $event"
                                    @update:editedItem="editedItem = $event"
                                    @showCountRestriction="showCountRestriction()"
                                    :invalidDropsPromo="invalidPromocode" />
                            </div>
                            <div class="summary" v-if="!$device.isDesktop && !allowChange">
                                <div class="container">
                                    <div
                                        class="summary__item"
                                        :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                                        <div class="cart__edit color-text_2 text_9" @click="editOrder">
                                            {{ $t("edit_order") }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
            <div class="cart__modal cart__modal--empty" v-else>
                <div class="mobile-cart-top" v-if="!$device.isDesktop && allowChange">
                    <div class="mobile-cart-top__left">
                        <div class="mobile-cart-top__logo">
                            <nuxt-link to="/" @click.native="close()">
                                <svg-icon name="logo" width="88" height="36" />
                            </nuxt-link>
                        </div>
                    </div>
                    <div class="mobile-cart-top__right">
                        <svg-icon name="close" @click="close()" width="32" height="32" />
                    </div>
                </div>
                <div class="cart__header">
                    <div class="container">
                        <span>{{ $t("cart") }}</span>
                        <div class="cart__close" @click="close()" v-if="$device.isDesktop">{{ $t("close") }}</div>
                    </div>
                </div>
                <div class="cart__list">
                    <div class="container" :class="{ 'color-text_2': allowChange, 'color-text_1': !allowChange }">
                        {{ $t("emty_cart") }}
                    </div>
                </div>
            </div>
            <div class="cart__dimmer" v-if="allowChange" @click="close()"></div>
        </div>
    </transition>
</template>
<script>
import CartItem from "~/components/CartItem";
import Input from "~/components/form/Input";
import Hint from "~/components/Hint";
import Loader from "~/components/Loader";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import { mapState } from "vuex/dist/vuex.common.js";
export default {
    name: "Cart",
    components: { Hint, Input, CartItem, Loader },
    props: ["allowChange", "initIsShowCart", "deliveryCost", "promoData", "skus", "invalidPromocode"],
    data() {
        return {
            isMobileListOpen: false,
            isShowPromocode: false,
            promocode: this.$store.getters["order/getPromoValue"],
            localIsShowCart: this.initIsShowCart,
            isShowCountRestriction: false,
            editedItem: {
                key: "",
                type: "",
            },
            promoValidation: {
                isValid: true,
                validationMessage: "",
            },
            bonuses: "",
            bonusesValidation: {
                isValid: true,
                validationMessage: "",
            },
        };
    },
    computed: {
        ...mapGetters({
            orderItems: "order/getItems",
            cartTotal: "order/getCartTotal",
            cartTotalDiscount: "order/getCartTotalDiscount",
            appliedBonuses: "order/getAppliedBonuses",
            liveItems: "order/getLiveItems",
            promoMessage: "order/getPromoMessage",
            promoDiscount: "order/getPromoDiscount",
            isShowCartState: "order/getCartOpenState",
            currency: "globalvars/getCurrency",
            locale: "globalvars/getLocale",
            minimumOrderPrice: "globalvars/getMinimumOrderPrice",
            storedPromo: "order/getPromoValue",
            discountInfo: "order/getDiscountInfo",
            isDeliveresLoading: "order/isDeliveresLoading",
        }),
        zakazRoute() {
            return '/zakaz/'
            // return this.$auth.loggedIn ? "/zakaz/" : "/lk/login/?redirect=zakaz";
        },
        currencyCode() {
            return this.locale.currency.currencyCode;
        },
        isShowCart() {
            return this.$route.name !== "uspeh-oformleniya-zakaza" && (this.localIsShowCart || this.isShowCartState);
        },
        maxWriteOffBonuses() {
            let maximumDiscountPercentagePerLevel = null;

            if (this.$auth.user.loyalty.level.privilegeSize === 5) {
                maximumDiscountPercentagePerLevel = 30;
            } else if (
                this.$auth.user.loyalty.level.privilegeSize === 10 ||
                this.$auth.user.loyalty.level.privilegeSize === 15 ||
                this.$auth.user.loyalty.level.privilegeSize === 20
            ) {
                maximumDiscountPercentagePerLevel = 100;
            }

            let orderTotal = this.promoData.total_with_discount
                ? this.promoData.total_with_discount
                : Number(this.cartTotal.replace(/\s/g, ""));
            let res = Math.floor((orderTotal / 100) * maximumDiscountPercentagePerLevel);

            if (this.$auth.user.loyalty.amount < res) {
                res = this.$auth.user.loyalty.amount;
            }

            if (orderTotal <= res) {
                res -= this.totalCartItems;
            }

            return res;
        },
        bonusesPlaceholder() {
            return `у тебя ${this.$auth.user.loyalty.amount} бонусов - спишем ${this.maxWriteOffBonuses}`;
        },
        preparedCartItems() {
            let items = [];
            if (this.liveItems.length > 0) {
                for (let key in this.orderItems) {
                    let liveItem = this.getLiveitem(this.orderItems[key].id);
                    if (
                        (liveItem && this.allowChange) ||
                        (!this.allowChange && liveItem.in_stock) ||
                        (!this.allowChange && liveItem.is_always_available)
                    ) {
                        let item = this.orderItems[key];
                        let sizes = this.getSizes(this.getLiveitem(key));
                        let drop = liveItem.drops && liveItem.drops.length ? liveItem.drops?.[0] : false;
                        if (item && liveItem) {
                            let preparedItem = {
                                id: item.id,
                                size: item.sizeName,
                                sizes: sizes,
                                count: item.count,
                                img: liveItem.images?.[0]?.path,
                                art: liveItem.vendor_code,
                                name: liveItem.product.name,
                                price: liveItem.currencies[this.currencyCode].discount_price
                                    ? liveItem.currencies[this.currencyCode].discount_price
                                    : liveItem.currencies[this.currencyCode].price,
                                currencies: liveItem.currencies,
                                is_soldout: liveItem.is_soldout,
                                is_always_available: liveItem.is_always_available,
                                fullPrice: liveItem.currencies[this.currencyCode].price,
                                discount: liveItem.discount ? liveItem.discount : false,
                                color: liveItem.color,
                                key: item.key,
                                inStock: liveItem.in_stock,
                                link: `/product/${liveItem.slug}`,
                                category: liveItem.product.category.name,
                                collection: liveItem.product.collection?.name || "Без колекции",
                                drop: drop,
                            };
                            items.push(preparedItem);
                        } else {
                            this.deleteItemFromDb(key);
                        }
                    } else {
                        this.deleteItemFromDb(key);
                    }
                }
            }
            return items;
        },
        hasDropItems() {
            let hasDrops = false;
            this.liveItems.forEach((el) => {
                if (el.drops && el.drops[0].promocode) {
                    hasDrops = true;
                }
            });
            return hasDrops;
        },
        hasItemsWithDiscount() {
            return !!this.liveItems.filter((order) => order.discount_price > 0).length;
        },
        totalCartItems() {
            let count = 0;
            for (const key in this.orderItems) {
                if (this.orderItems.hasOwnProperty(key)) {
                    const element = this.orderItems[key];
                    count += element.count;
                }
            }
            return count;
        },
        isReachMinimumOrderPrice() {
            return parseInt(this.cartTotal.replace(/\s+/g, "")) >= this.minimumOrderPrice;
        },
    },
    watch: {
        storedPromo(val) {
            this.promocode = val;
        },
        promoMessage(newVal) {
            this.promoValidation = {
                isValid: this.promoDiscount ? true : false,
                validationMessage: newVal,
            };
        },
        invalidPromocode(val) {
            if (val) {
                this.promoValidation = {
                    isValid: false,
                    validationMessage: "",
                };
            }
        },
        initIsShowCart(val) {
            this.localIsShowCart = val;
        },
        $route() {
            this.close();
        },
        cartTotal(val) {
            localStorage["lastAmount"] = val.replace(/\s+/g, "");
            sessionStorage.removeItem("storedOrderData");
        },
        async totalCartItems(val) {
            if (this.discountInfo.isApply) {
                if (this.discountInfo.discountType === "promo-code") {
                    await this.resetPromo();
                }
                if (this.discountInfo.discountType === "bonuses") {
                    await this.resetBonuses();
                }
            }
            if (val) {
                if (location.href.indexOf("/zakaz") > -1) {
                    setTimeout(() => {
                        function get_items() {
                            const cartAmount =
                                parseInt(document.querySelector("#carrotCartTotal").textContent.replace(/\D/g, "")) ||
                                0;

                            localStorage["lastAmount"] = cartAmount;
                        }
                        get_items();

                        document.addEventListener("click", function (e) {
                            if (e.target.matches(".cart-item__remove")) {
                                setTimeout(function () {
                                    get_items();
                                }, 1000);
                            } else if (e.target.matches(".carrot-order-button")) {
                                localStorage["orderStarted"] = true;
                            }
                        });
                    }, 400);
                }
            }
        },
        bonuses(val) {
            if (val) {
                this.$refs.bonuses.$el.lastElementChild.style.display = "none";
            } else {
                this.$nextTick(function () {
                    this.$refs.bonuses.$el.lastElementChild.style.display = "unset";
                });
            }
        },
    },
    methods: {
        ...mapActions({
            deleteItemFromDb: "order/deleteItemFromDb",
        }),
        close() {
            this.$emit("close");
            this.$store.commit("order/setCartOpenState", false);
        },
        applyPromo(allow) {
            this.$emit("update:promocodeValidate", { phone: !!allow.phone, email: !!allow.email });
            this.$emit("invalidPromocode", "");
            if (allow.phone && allow.email && this.promocode) {
                this.$store.dispatch("order/applyPromocode", { promocode: this.promocode, ...allow, skus: this.skus });
            } else {
                if (!this.promocode) {
                    this.$store.commit("order/setPromoMessage", this.$i18n.t("enter_promo_pls"));
                } else {
                    this.$store.commit("order/setPromoMessage", this.$i18n.t("promo_error"));
                }
            }
        },
        resetPromo() {
            this.$store.dispatch("order/applyPromocode", { promocode: "", phone: "", email: "" });
        },
        applyBonuses() {
            if (this.hasItemsWithDiscount) {
                this.bonusesValidation.isValid = false;
                this.bonusesValidation.validationMessage = this.$i18n.t("cannot_use_bonuses_with_discounts");
                this.bonuses = "";
                return;
            }

            if (!new RegExp("^[0-9]").test(this.bonuses)) {
                this.bonuses = this.maxWriteOffBonuses;
            }

            if (!this.bonuses || this.bonuses > this.maxWriteOffBonuses) {
                this.bonuses = this.maxWriteOffBonuses;
            }

            this.$store.dispatch("order/applyDiscountBonuses", {
                skus: this.skus,
                appliedBonuses: this.bonuses,
                currency: this.currencyCode,
            });
        },
        resetBonuses() {
            this.bonuses = "";
            this.$store.dispatch("order/resetDiscountBonuses");
        },
        editOrder() {
            localStorage.setItem("showMeCart", "true");
            this.$router.push("/");
        },
        editItem(key, type) {
            if (this.allowChange) {
                this.editedItem = {
                    key,
                    type,
                };
            }
        },
        getLiveitem(id) {
            return this.liveItems.filter((liveItem) => liveItem.id == id)[0];
        },
        getSizes(item) {
            let sizes = item.product.skus.filter((skus) => {
                return skus.color_id == item.color.id;
            });
            if (sizes.length > 0) {
                return sizes[0].sizes;
            }
            return [];
        },

        showCountRestriction() {
            this.isShowCountRestriction = true;
            setTimeout(() => {
                this.isShowCountRestriction = false;
            }, 3000);
        },
    },
};
</script>
<style lang="less" scoped>
.cart-total {
    @media @sm {
        margin-top: 16px;
    }
}
.count-restriction {
    position: fixed;
    top: 35px;
    right: 0;
    border: 1px solid #dda491;
    padding: 16px;
    color: #000;
    width: 342px;
    max-width: 100%;
    background: @bg;
    z-index: 6;
    div + div {
        margin-top: 4px;
        color: #dda491;
    }
}
.mobile-cart-top {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: 0 7px 0 16px;
    border-bottom: 1px solid @border2;
    a,
    svg {
        display: block;
    }
}
.cart {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 7;
    cursor: default;
    &.blocked {
        position: sticky;
        position: -webkit-sticky;
        top: 72px;
    }
    .container {
        position: static;
    }
    &__coninue-shopping {
        margin-top: 8px;
    }
    &__dimmer {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0.7;
        background: #f2f1e9;
        z-index: 0;
    }
    &__modal {
        z-index: 1;
        background: @bg;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        border-left: 1px solid @border2;
        @media @sm {
            border-left: 0;
        }
        .editable & {
            width: 645px;
            max-width: 100%;
            position: absolute;
            .cart__content {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                width: 645px;
                flex-shrink: 0;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                @media @sm {
                    position: static;
                    width: 100%;
                }
            }
        }
        .blocked & {
            padding-top: 40px;
            padding-bottom: 40px;
            border-left: 0;
            .cart__content {
                flex-grow: 1;
            }
            @media @sm {
                padding-top: 24px;
                padding-bottom: 0;
                border-left: 0;
            }
        }
        &--empty {
            display: block;
            @media @sm {
                text-align: center;
                .cart__list {
                    .container {
                        padding-top: 32px;
                    }
                }
            }
        }
    }
    &__header {
        .editable & {
            height: 37px;
            flex-shrink: 0;
            border-bottom: 1px solid @border2;
        }
        .container {
            display: flex;
            height: 100%;
            align-items: center;
            @media @sm {
                justify-content: center;
                .blocked & {
                    display: block;
                    justify-content: flex-start;
                }
            }
        }
    }
    &__mobile-list-toggler {
        padding: 16px 16px;
        margin-top: 24px;
        display: flex;
        align-items: baseline;
        justify-content: center;
        border-top: 1px solid @border2;
        border-bottom: 1px solid @border2;
        svg {
            .trs(transform);
        }
        .text_11 {
            .trs(color);
        }
        &.is_open {
            .text_11 {
                color: #000;
            }

            svg {
                transform: rotate(180deg);
            }
        }
    }
    &__count {
        &:before {
            content: "/";
            display: inline-block;
            margin: 0 8px 0 5px;
        }
    }
    &__close,
    &__edit {
        margin-left: auto;
        border-bottom: 1px solid;
        cursor: pointer;
        .trs(color);
        &:hover {
            color: @accent;
        }
    }
    &__edit {
        border-bottom: 1px solid;
        @media @sm {
            margin-top: 16px;
        }
    }
    &__list {
        overflow: hidden;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        > .container {
            padding: 32px;
            flex-grow: 1;
            overflow-y: auto;
            @media @sm {
                padding: 16px;
            }
        }

        .blocked & {
            @media @sm {
                padding-bottom: 16px;
            }
        }
    }
    &__checkout {
        background: #000;
        color: #fff;
        display: flex;
        padding: 12px;
        margin-top: 19px;
        justify-content: center;
        @media @sm {
            padding: 16px;
        }
        &:hover {
            background: @accent;
            color: #fff !important;
        }
        &--locked {
            background: @text_2;
            color: #fff;
            padding: 20px;
            text-align: center;
            cursor: default;
            @media @sm {
                padding: 16px;
            }
        }
    }
}
.discounts {
    display: flex;
    flex-direction: column;
    gap: 40px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 32px;
    border-bottom: 1px solid @border2;

    .button {
        margin-left: 16px;
    }
    .form-group__label {
        margin-top: 0;
        font-size: 14px;
    }
    @media @sm {
        padding: 0;
        border-bottom: 0;
        .button {
            margin-left: 18px;
        }
    }
    .promocode__toggler {
        cursor: pointer;
        &:hover {
            color: #000;
        }
        span {
            display: inline-block;
            .trs(transform);
        }
    }
    .promocode__deny {
        margin-top: 10px;
    }
}
.summary {
    padding: 32px 0 9px;
    border-bottom: 1px solid @border2;
    @media @sm {
        padding: 16px 0 8px;
    }
    .blocked & {
        padding-bottom: 40px;
        @media @sm {
            padding-top: 16px;
            padding-bottom: 16px;
            border-bottom: 0;
            .container {
                padding-top: 0;
                padding-bottom: 0;
            }
            .cart__edit {
                margin-left: 0;
                margin-top: 0;
            }
            .summary__label {
                &:after {
                    content: "/";
                    padding: 0 8px;
                }
            }
            .summary__value {
                flex-grow: 1;
                display: flex;
                &--price {
                    align-items: baseline;
                    text-align: right;
                }
            }
        }
    }
    &__label {
        svg {
            cursor: pointer;
            .trs(opacity);
            &:hover {
                opacity: 0.5;
            }
        }
    }
    &__value {
        @media @sm {
            svg {
                margin-left: auto;
                margin-top: 3px;
                margin-right: 1px;
            }
        }
    }
    &__item {
        display: flex;
        justify-content: space-between;
        gap: 8px;
        .blocked & {
            @media @sm {
                justify-content: start;
                .hint {
                    margin-left: auto;
                }
            }
        }

        & + & {
            margin-top: 4px;
            &.text_19 {
                margin-top: 14px;
            }
        }
        &:last-child {
            margin-top: 16px;
            @media @sm {
                margin-top: 24px;
                .blocked & {
                    margin-top: 4px;
                }
            }
        }
    }
}
.drop-warning {
    margin-top: 8px;
    svg {
        margin-right: 4px;
        vertical-align: middle;
    }
    &--offset {
        margin-top: 15px;
    }
    &--aaaaaaa {
        color: @red2;
    }
}
</style>
